const initalState = {
    products: [],
    tagName: 'BagProduct'
}


export default function CartReducer(state = initalState, action) {
    var result;
    switch (action.type) {
        case 'SET_CART':
            result = { ...state, products: action.products }
            break;       
        case 'UPDATE_CART':
            result = { ...state, products: [...state.products, action.updatedProduct] }
            break;
        case 'REMOVE_CART':
            result = {
                state, products: state.products.filter(product => {
                    return product.id !== action.removedProduct.id
                })
            }
            break;
        default:
            result = state;
            break;
    }
    return result;

}